export default __webpack_public_path__ + "static/media/download_button_iphone.adc576a3.png";